export default __webpack_public_path__ + "static/media/greencheck.1b92b259.svg";